"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _material = require("@ori-ui/mui-bundle/material");
var _jsxRuntime = require("react/jsx-runtime");
var _default = exports.default = (0, _material.createSvgIcon)(/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M8 10V8c0-.562.137-1.544.709-2.402C9.302 4.708 10.334 4 12 4s2.698.708 3.291 1.598C15.863 6.456 16 7.438 16 8v2h.5a1.5 1.5 0 0 1 1.5 1.5v7a1.5 1.5 0 0 1-1.5 1.5h-9A1.5 1.5 0 0 1 6 18.5v-7A1.5 1.5 0 0 1 7.5 10zm1-2v2h6V8c0-.438-.113-1.206-.541-1.848C14.052 5.542 13.334 5 12 5s-2.052.542-2.459 1.152C9.113 6.794 9 7.562 9 8m3 6a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 1 0v-2a.5.5 0 0 0-.5-.5"
}), 'LockFilled');
//# sourceMappingURL=index.js.map